export function getRelatedItems(mapItem: any, previewItems: any[]) {
  let mapItems = previewItems.map((item: any) => {
    let [dimStr, agg, _] = item.filename.split(".");
    let dimList = dimStr.split("__");
    let F = !item.filter ? null : Object.entries(item.filter);
    return [
      agg, 
      dimList[0], 
      dimList?.[1] || null, 
      !F ? null : `${F[0][0]}__${F[0][1]}`, 
      !F || F.length < 2 ? null : `${F[1][0]}__${F[1][1]}`
    ]
  });

  let filterItems = mapItems.filter((item: any) => diff(item, mapItem) === 1);
  let s = selectable(filterItems, mapItem);

  return s;
}

/** แปลง previewItem หนึ่งรายการเป็น mapItem 5 ช่อง — กติกาเดียวกับ getRelatedItems */
function toMapItem(item: any) {
  const [dimStr, agg] = item.filename.split(".");
  const dimList = dimStr.split("__");
  const F = !item.filter ? null : Object.entries(item.filter);
  return [
    agg,
    dimList[0],
    dimList?.[1] || null,
    !F ? null : `${F[0][0]}__${F[0][1]}`,
    !F || F.length < 2 ? null : `${F[1][0]}__${F[1][1]}`,
  ];
}

/**
 * หาชื่อไฟล์ parquet ที่ตรงกับ mapItem จาก previewItems
 *
 * ต้องใช้ชื่อจาก chartinfo เท่านั้น ห้ามประกอบชื่อเอง เพราะ pipeline ทำสองอย่างที่ UI
 * เลียนแบบไม่ได้: clean() ยุบ _ ซ้ำและตัด _ หัวท้าย (commands/gen_thumbnails.py) และ
 * safe_filename() ตัดชื่อที่ยาวเกิน 240 ไบต์แล้วต่อด้วย md5 12 หลัก
 * (มี 1,747 ไฟล์ที่ผ่านการตัดแบบนี้ ซึ่งเดิม UI เปิดไม่ได้เลย)
 *
 * คืน null เมื่อหาไม่เจอ ให้ผู้เรียกตัดสินใจว่าจะ fallback หรือแจ้ง error
 */
export function findFilename(mapItem: any, previewItems: any[]) {
  for (const item of previewItems || []) {
    const candidate = toMapItem(item);
    if (candidate.every((value, index) => value === mapItem[index])) {
      return item.filename as string;
    }
  }
  return null;
}

export function getMapItem(filename: string, filter: string) {
  let [dimStr, agg_, _] = filename.split(".");
  let dimList = dimStr.split("__");
  let G = !filter ? null : filter?.split("__")
    .reduce((acc: any[], cur: string, index: number) => {
      if (index % 2 === 0) {
        acc.push(`${cur}__`);
      } else {
        acc[acc.length - 1] = acc[acc.length - 1] + cur;
      }
      return acc;
    }, []);
  let mapItem = [
    agg_,
    dimList[0], 
    dimList?.[1] || null, 
    !G ? null : G[0], 
    !G || G.length < 2 ? null : G[1]
  ];
  return mapItem
}

function diff(a: any, b: any) {
  let count = a.map((i: any, index: number) => (i === b[index] ? 0 : 1))
               .reduce((acc: number, cur: number) => acc + cur, 0);
  return count
}

/**
 * หา "ก้าวที่สั้นที่สุด" จากกราฟที่เปิดอยู่ ไปยังกราฟที่ Filter 2 ใช้งานได้
 *
 * ทำไมต้องมี: dropdown ทุกช่องเลือกได้เฉพาะค่าที่มีไฟล์ parquet รองรับ และ getRelatedItems
 * ยอมให้ต่างจากสถานะปัจจุบันได้ทีละ 1 ช่องเท่านั้น กราฟที่มี Filter 2 จึงมักอยู่ห่างเกิน 1 ก้าว
 * ทำให้ Filter 2 เทาโดยไม่มีอะไรอธิบาย ฟังก์ชันนี้บอกว่าต้องเปลี่ยนช่องไหนเป็นอะไรบ้าง
 *
 * ไม่ hardcode กฎว่า "ต้องเป็นเดือน + กรองด้วยปี" เพราะแต่ละ dataset ไม่เหมือนกัน
 * (mor_redmine มีกราฟ 2 filter ที่แบ่งสีด้วย status_label ได้ ต่างจาก dataset อื่น)
 * จึงอ่านจาก previewItems ที่ pipeline สร้างจริงแทน
 *
 * คืน null เมื่อ dataset นี้ไม่มีกราฟที่มี Filter 2 เลย
 */
export function getFilter2Path(mapItem: any, previewItems: any[]) {
  let best: { index: number, value: any }[] | null = null;

  for (const item of previewItems || []) {
    const [dimStr, agg] = item.filename.split(".");
    const dimList = dimStr.split("__");
    const F = !item.filter ? null : Object.entries(item.filter);
    if (!F || F.length < 2) continue; // สนใจเฉพาะกราฟที่มี Filter 2

    const target = [
      agg,
      dimList[0],
      dimList?.[1] || null,
      `${F[0][0]}__${F[0][1]}`,
    ];

    // เทียบเฉพาะ index 0-3 — index 4 คือ Filter 2 ซึ่งเป็นปลายทางที่ต้องการอยู่แล้ว
    const changes = target
      .map((value, index) => ({ index, value }))
      .filter(({ index, value }) => mapItem[index] !== value);

    if (!best || changes.length < best.length) best = changes;
    if (best.length === 0) break;
  }

  return best;
}

function selectable(filterItems: any[], mapCur: any) {
  let output: [any[], any[], any[], any[], any[]] = 
    [[mapCur[0]], [mapCur[1]], [mapCur[2]], [mapCur[3]], [mapCur[4]]];
  for (const mapItem of filterItems) {
    for (var i = 0; i < 5; i++) {
      if (mapCur[i] !== mapItem[i]) {
        output[i].push(mapItem[i]);
      }
    }
  }
  return output.map((items: any) => items.sort());
}
